import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_PROMOTE_SHARE_ON_COMBO_EXPERIMENT = defineFcm('promote_share_on_combo_experiment')
	.asJson(
		createShapeNormalizer({
			type: 'object',
			shape: {
				enabled: { type: 'boolean' },
				experimentName: { type: 'string' },
				// Country the experiment may run in. Guards the hardcoded amount ladder in
				// normalizePromoteFormData, which ignores the server's per-country
				// amountChoices and is only valid where the country's minimumAmount is <= the
				// lowest chip.
				countryCode: { type: 'string', optional: true },
				exclusion_group_experiment_id: { type: 'string', optional: true },
			},
		}),
	)
	.withDefault(undefined)
	.toConfig({
		owner: 'squad-koi',
		scope: 'corgi-front-end',
		context: 'psf combo page',
		description: 'Promote share on combo experiment',
		template: {
			enabled: false,
			experimentName: 'promote_share_on_combo',
			countryCode: 'US',
			exclusion_group_experiment_id: 'promote_share_on_combo_experiment',
		},
		deprecated: 'FCM no longer in use (payment on combo R7 stopped) — safe to delete after 2026-11-02',
	});
